import React from 'react';
import cn from 'classnames';

type BadgeProps = {
  id: string
  type: 'blue' | 'yellow' | 'red' | 'gray' | 'green'
  caption: string
  className?: string
  onClose?: (value: string) => void
}

export default function Badge({
  id, type, caption, className, onClose,
}: BadgeProps) {
  const color = {
    'bg-gray text-white font-bold': type === 'gray',
    'bg-yellow text-white font-bold': type === 'yellow',
    'bg-red text-white font-bold': type === 'red',
    'bg-green text-white font-bold': type === 'green',
    'bg-blue text-white font-bold': type === 'blue',
  };
  return (
    <>
      {caption.length > 0 &&
      <span id={id}
        className={cn('inline-flex items-center px-2.5 py-1 rounded-full', color, className)}>
        {caption}
        {onClose &&
        <button type="button" onClick={() => onClose(id)}
          className="flex-shrink-0 ml-0.5 h-4 w-4 rounded-full inline-flex items-center justify-center focus:outline-none
            hover:bg-gray-dark">
          <span className="sr-only">Remove</span>
          <svg className="h-2 w-2" stroke="currentColor" fill="none" viewBox="0 0 8 8">
            <path strokeLinecap="round" strokeWidth="1.5" d="M1 1l6 6m0-6L1 7"/>
          </svg>
        </button>
        }
      </span>
      }
    </>
  );
}
